import { Icon } from '@iconify/react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import { useBranding } from '@/branding/BrandingProvider'

export function DashboardPage() {
  const { user, logout } = useAuth()
  const { siteName } = useBranding()

  return (
    <div className="min-h-screen bg-slate-50">
      <nav className="bg-white border-b border-slate-100 h-16 flex items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-navy flex items-center justify-center">
            <Icon icon="solar:health-linear" className="text-white text-sm" />
          </div>
          <span className="text-lg font-medium text-navy tracking-tight">{siteName}</span>
        </Link>
        <button
          onClick={() => logout()}
          className="text-sm text-slate-500 hover:text-navy transition-colors"
        >
          Logout
        </button>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-2xl font-medium tracking-tight text-navy mb-2">
          Welcome, {user?.name || user?.email || 'User'}
        </h1>
        <p className="text-slate-500 font-light mb-8">Manage your {siteName} account.</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Link
            to="/account/orders"
            className="bg-white border border-slate-200 rounded-xl p-6 hover:border-navy/20 hover:shadow-md transition-all"
          >
            <Icon icon="solar:bag-4-linear" className="text-2xl text-navy mb-3" />
            <h3 className="font-medium text-navy mb-1">Order History</h3>
            <p className="text-sm text-slate-500 font-light">View past orders and status.</p>
          </Link>

          <Link
            to="/account/profile"
            className="bg-white border border-slate-200 rounded-xl p-6 hover:border-navy/20 hover:shadow-md transition-all"
          >
            <Icon icon="solar:user-linear" className="text-2xl text-navy mb-3" />
            <h3 className="font-medium text-navy mb-1">Profile</h3>
            <p className="text-sm text-slate-500 font-light">Update your information.</p>
          </Link>

          <Link
            to="/cart"
            className="bg-white border border-slate-200 rounded-xl p-6 hover:border-navy/20 hover:shadow-md transition-all"
          >
            <Icon icon="solar:cart-large-minimalistic-linear" className="text-2xl text-navy mb-3" />
            <h3 className="font-medium text-navy mb-1">Cart</h3>
            <p className="text-sm text-slate-500 font-light">Continue shopping.</p>
          </Link>
        </div>
      </div>
    </div>
  )
}
